import { SortDirection, SortParam, SortState } from './types';

export const buildSortState = (sortParam: SortParam) => {
  const { direction } = sortParam;
  const state = [];
  if (direction !== null) state.push(sortParam);
  return state;
};

export const getSortDirection = (sortState: SortState, id: string) => {
  return sortState.find((param) => param.id === id)?.direction ?? null;
};

export const getNextSortDirection = (direction: SortDirection) => {
  switch (direction) {
    case 'asc':
      return 'desc';
    case 'desc':
      return null;
    default:
      return 'asc';
  }
};

export const getSortTitle = (sortState: SortState, id: string) => {
  const direction = getSortDirection(sortState, id);
  const nextSortDirection = getNextSortDirection(direction);

  switch (nextSortDirection) {
    case 'asc':
      return 'Sort ascending';
    case 'desc':
      return 'Sort descending';
    default:
      return 'Clear sort';
  }
};
